import {
  centredRegion,
  decodeImage,
  dimensionsOf,
  drawRegion,
  toJpegBlob,
} from "@/pages/MediaImages/imageVariants";

/**
 * An employee's photo is one square JPEG in `users.avatar`; the monolith's per-admin crops
 * (`media_images`, 150x160 / 100x100 / 200x200) are abandoned. The square is cut here, so
 * cms-api only stores bytes and the editor sees exactly what will be saved.
 */
export const AVATAR_SIZE = 400;

// cms-api refuses anything else
export const ACCEPTED_TYPES = ["image/jpeg", "image/png", "image/webp"];
export const MAX_BYTES = 5 * 1024 * 1024;

/**
 * The largest centred square, scaled down to AVATAR_SIZE — never enlarged, a small photo stays
 * at its native pixels.
 * @returns {Promise<Blob>}
 */
export const buildAvatar = async (file) => {
  const image = await decodeImage(file);
  try {
    const { width, height } = dimensionsOf(image);
    const side = Math.min(width, height);
    const size = Math.min(side, AVATAR_SIZE);

    return await toJpegBlob(drawRegion(image, centredRegion(width, height, side, side), size, size));
  } finally {
    if (typeof image.close === "function") image.close();
  }
};
